import {scrollToElement} from '@/utils/scrollToElement';

const QUIZ_ID = 'quiz';

export const scrollToQuiz = (): void => {
  scrollToElement(QUIZ_ID);
};
